import React from 'react';
import { Col, Form, Input, Radio, Row, Select } from 'antd';

const { Option } = Select;

export type InvoiceType = 'personal' | 'corporate';

const cities = [
  'Adana', 'Adıyaman', 'Afyonkarahisar', 'Ağrı', 'Amasya', 'Ankara', 'Antalya', 'Artvin', 'Aydın', 'Balıkesir',
  'Bilecik', 'Bingöl', 'Bitlis', 'Bolu', 'Burdur', 'Bursa', 'Çanakkale', 'Çankırı', 'Çorum', 'Denizli',
  'Diyarbakır', 'Edirne', 'Elazığ', 'Erzincan', 'Erzurum', 'Eskişehir', 'Gaziantep', 'Giresun', 'Gümüşhane',
  'Hakkâri', 'Hatay', 'Isparta', 'Mersin', 'İstanbul', 'İzmir', 'Kars', 'Kastamonu', 'Kayseri', 'Kırklareli',
  'Kırşehir', 'Kocaeli', 'Konya', 'Kütahya', 'Malatya', 'Manisa', 'Kahramanmaraş', 'Mardin', 'Muğla', 'Muş',
  'Nevşehir', 'Niğde', 'Ordu', 'Rize', 'Sakarya', 'Samsun', 'Siirt', 'Sinop', 'Sivas', 'Tekirdağ', 'Tokat',
  'Trabzon', 'Tunceli', 'Şanlıurfa', 'Uşak', 'Van', 'Yozgat', 'Zonguldak', 'Aksaray', 'Bayburt', 'Karaman',
  'Kırıkkale', 'Batman', 'Şırnak', 'Bartın', 'Ardahan', 'Iğdır', 'Yalova', 'Karabük', 'Kilis', 'Osmaniye', 'Düzce',
];

interface BillingDetailsFieldsProps {
  invoiceType: InvoiceType;
  onInvoiceTypeChange: (type: InvoiceType) => void;
}

const BillingDetailsFields: React.FC<BillingDetailsFieldsProps> = ({ invoiceType, onInvoiceTypeChange }) => (
  <>
    <Form.Item label={<strong>Faturalandırma Seçenekleri</strong>}>
      <Radio.Group value={invoiceType} onChange={(event) => onInvoiceTypeChange(event.target.value)}>
        <Radio value="personal">Bireysel Fatura</Radio>
        <Radio value="corporate">Kurumsal Fatura</Radio>
      </Radio.Group>
    </Form.Item>
    <Row gutter={16}>
      <Col xs={24} md={12}>
        <Form.Item name="firstName" label="Ad" rules={[{ required: true, message: 'Adınızı girin.' }, { pattern: /^[a-zA-ZğüşöçİĞÜŞÖÇı ]+$/, message: 'Ad yalnızca harf içermelidir.' }]}>
          <Input placeholder="Adınız" />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item name="lastName" label="Soyad" rules={[{ required: true, message: 'Soyadınızı girin.' }, { pattern: /^[a-zA-ZğüşöçİĞÜŞÖÇı ]+$/, message: 'Soyad yalnızca harf içermelidir.' }]}>
          <Input placeholder="Soyadınız" />
        </Form.Item>
      </Col>
    </Row>
    {invoiceType === 'personal' ? (
      <Form.Item name="identityNumber" label="TC Kimlik Numarası" rules={[{ required: true, message: 'TC kimlik numaranızı girin.' }, { pattern: /^\d{11}$/, message: 'TC kimlik numarası 11 haneli olmalıdır.' }]}>
        <Input inputMode="numeric" maxLength={11} />
      </Form.Item>
    ) : (
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item name="companyName" label="Firma Adı" rules={[{ required: true, message: 'Firma adını girin.' }]}><Input /></Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item name="taxNumber" label="Vergi Kimlik Numarası" rules={[{ required: true, message: 'Vergi kimlik numarasını girin.' }, { pattern: /^\d{10,11}$/, message: 'Vergi kimlik numarası 10 veya 11 haneli olmalıdır.' }]}><Input inputMode="numeric" /></Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item name="taxOffice" label="Vergi Dairesi" rules={[{ required: true, message: 'Vergi dairesini girin.' }]}><Input /></Form.Item>
        </Col>
      </Row>
    )}
    <Row gutter={16}>
      <Col xs={24} md={12}>
        <Form.Item name="phone" label="Cep Telefonu" rules={[{ required: true, message: 'Telefon numaranızı girin.' }, { pattern: /^\d{10}$/, message: 'Telefon numarası 10 haneli olmalıdır.' }]}>
          <Input inputMode="numeric" maxLength={10} placeholder="5XXXXXXXXX" />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item name="email" label="E-posta" rules={[{ required: true, message: 'E-posta adresinizi girin.' }, { type: 'email', message: 'Geçerli bir e-posta adresi girin.' }]}>
          <Input />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={16}>
      <Col xs={24} md={12}>
        <Form.Item name="city" label="İl" rules={[{ required: true, message: 'İl seçin.' }]}>
          <Select showSearch optionFilterProp="children" placeholder="İl seçin">
            {cities.map((city) => <Option key={city} value={city}>{city}</Option>)}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item name="billingAddress" label="Fatura Adresi" rules={[{ required: true, message: 'Fatura adresini girin.' }]}>
          <Input />
        </Form.Item>
      </Col>
    </Row>
  </>
);

export default BillingDetailsFields;
